import { Component, ComponentInterface, Element, Method, Prop } from '@stencil/core';

/** @experimental */
@Component({
  tag: 'wb-header-flyout',
  styleUrl: 'flyout.scss',
})
export class HeaderFlyoutComponent implements ComponentInterface {
  @Element()
  public el: HTMLElement;

  private bodyEl: HTMLElement = undefined;

  private topbarEl: HTMLElement = undefined;

  /** specifies the level which the element should fulfill, styling will be applied accordingly */
  @Prop({ reflect: true })
  public level: 1 | 2 | 3 = 1;

  /** will be set to automatically once the user scrolls above or below the threshold (half the flyouts topbar height) */
  @Prop({ reflect: true })
  public scrolled: boolean = false;

  /** if present the flyout is visible */
  @Prop({ reflect: true, mutable: true })
  public open: boolean = false;

  /** sets the `open` property to `true` */
  @Method()
  public async show(): Promise<void> {
    this.open = true;
  }

  /** sets the `open` property to `false` */
  @Method()
  public async hide(): Promise<void> {
    this.open = false;
  }

  /** toggles the `open` property between `true` and `false` */
  @Method()
  public async toggle(): Promise<void> {
    this.open = !this.open;
  }

  public connectedCallback(): void {
    this.bodyEl = this.el.querySelector('.wb-header-flyout__body');
    this.topbarEl = this.el.querySelector('.wb-header-flyout__topbar');

    if (this.bodyEl && this.topbarEl) {
      this.bodyEl.addEventListener('scroll', this.handleBodyScroll);
    }
  }

  private handleBodyScroll = (): void => {
    this.scrolled = this.bodyEl.scrollTop > this.topbarEl.clientHeight / 2;
  };

  public disconnectedCallback(): void {
    this.bodyEl?.removeEventListener('scroll', this.handleBodyScroll);
  }
}
